import { render, staticRenderFns } from "./instruction-card.vue?vue&type=template&id=24b6f122&scoped=true&"
import script from "./instruction-card.vue?vue&type=script&lang=js&"
export * from "./instruction-card.vue?vue&type=script&lang=js&"
import style0 from "./instruction-card.vue?vue&type=style&index=0&id=24b6f122&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6f122",
  null
  
)

export default component.exports